/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon, Link } from '@zapier/design-system';

type ExternalLinkProps = {
  /** Link */
  href: string;
  /** Text to turn into a link */
  children: string;
  /** Passed on to `<Link>` for custom styling like font-size */
  className?: string;
};

const Styles = {
  link: {
    fontWeight: 700,
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'max-content auto',
    columnGap: 5,
  },
};

/** Renders an external link with icon. */
const ExternalLink = ({ className, href, children }: ExternalLinkProps) => (
  <Link className={className} css={Styles.link} href={href} target="_blank">
    {children} <Icon name="arrowOffsite" size={18} />
  </Link>
);

export default ExternalLink;
